import { Component, OnInit } from "@angular/core";
import { NavigationService } from "../../services/navigation.service";

@Component({
  selector: "app-back-button",
  templateUrl: "./back-button.component.html",
  styleUrls: ["./back-button.component.scss"],
})
export class BackButtonComponent implements OnInit {
  constructor(private navigationService: NavigationService) {}

  ngOnInit(): void {}

  back() {
    this.navigationService.back();
  }
}
